import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Paper, ClickAwayListener, Portal } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  picker: {
    position: "absolute",
    zIndex: 1300,
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[4],
    display: "flex",
    gap: theme.spacing(0.5),
    flexWrap: "wrap",
    maxWidth: "280px",
  },
  emoji: {
    fontSize: "24px",
    cursor: "pointer",
    padding: theme.spacing(0.5),
    borderRadius: theme.shape.borderRadius,
    transition: "background-color 0.2s",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

// Emojis mais usados no WhatsApp
const COMMON_EMOJIS = [
  "👍", "❤️", "😂", "😮", "😢", "🙏", "👏", "🔥",
  "😊", "🎉", "💯", "👌", "😍", "🤔", "😴", "😎"
];

const ReactionPicker = ({ anchorEl, open, onClose, onSelectEmoji }) => {
  const classes = useStyles();
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (open && anchorEl) {
      const anchorRect = anchorEl.getBoundingClientRect();
      setPosition({
        top: anchorRect.top - 60 + window.scrollY,
        left: anchorRect.left - 20 + window.scrollX,
      });
    }
  }, [open, anchorEl]);

  const handleEmojiClick = (emoji) => {
    onSelectEmoji(emoji);
    onClose();
  };

  if (!open || !anchorEl) return null;

  return (
    <Portal>
      <ClickAwayListener onClickAway={onClose}>
        <Paper 
          className={classes.picker} 
          style={{
            position: "absolute",
            top: position.top,
            left: position.left,
          }}
        >
          {COMMON_EMOJIS.map((emoji, index) => (
            <span
              key={index}
              className={classes.emoji}
              onClick={() => handleEmojiClick(emoji)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleEmojiClick(emoji);
                }
              }}
            >
              {emoji}
            </span>
          ))}
        </Paper>
      </ClickAwayListener>
    </Portal>
  );
};

export default ReactionPicker;
